import { LocaleEnum } from 'schema/locale';
import { config } from 'shared/config';
import { routes } from 'constants/routes';
import { SitemapPageType } from '../types';

interface GetSitemapHref {
  slug: string;
  type: SitemapPageType;
  locale: LocaleEnum;
}

const getRoute = (slug: string, type: SitemapPageType) => {
  switch (type) {
    case 'page':
      return slug;
    case 'faqPage':
      return routes.faq;
    case 'eduArticles':
      return routes.eduHubPost({ slug });
    case 'eduCategory':
      return routes.eduHubCategory({ slug });
    case 'eduTag':
      return routes.eduHubTag({ slug });
    case 'eduSettings':
      return routes.eduHub;
    default:
      return slug;
  }
};

export const getSitemapHref = ({ slug, type, locale }: GetSitemapHref) =>
  `${config.NEXT_PUBLIC_AG_URL}/${locale === LocaleEnum.enUS ? '' : `${locale}/`}${getRoute(
    slug,
    type
  ).replace(/^\//g, '')}`.replace(/\/*$/, '');
